import styled from "styled-components";
import { gridGutters } from "../../styles/grid";

export const TimerLayout = styled.div`
    position: absolute;
    top: ${gridGutters(2)};
    left: ${gridGutters(1)};
`;
